import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ToggleTheme.module.scss';
import NightModeIcon from '../../assets/night.svg';
import ToogleButton from './ToogleButton';
import { useTranslation } from 'react-i18next';
const DARK = 'dark';
const LIGHT = 'light';
const ToggleTheme = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("div", { children: _jsx(NightModeIcon, {}) }), _jsx("div", { children: _jsx("span", { children: t('darkMode') }) }), _jsx("div", { children: _jsx(ToogleButton, {}) })] }));
};
export default ToggleTheme;
